import React from "react";
import { FiEdit3, FiRefreshCw, FiTrendingUp, FiUploadCloud, FiZap } from "react-icons/fi";

/**
 * Shared mapping for "activity" log types — the events that reach the site
 * automatically (ForexAPI sync, feed auto-publish) plus the manual deploy /
 * promote actions. Used by the deployment page activity feed AND the dashboard
 * recent-activity widget so both render the same automatic updates consistently.
 */
export type ActivityTone = "emerald" | "orange" | "sky" | "indigo" | "slate";
export type ActivityMeta = { label: string; icon: React.ReactNode; tone: ActivityTone };

export const ACTIVITY_META: Record<string, ActivityMeta> = {
	"content-auto-publish": { label: "Auto-publié", icon: <FiZap />, tone: "emerald" },
	"content-update": { label: "Modification", icon: <FiEdit3 />, tone: "slate" },
	"forex-rates": { label: "Taux publiés", icon: <FiTrendingUp />, tone: "emerald" },
	"forex-sync": { label: "Sync ForexAPI", icon: <FiRefreshCw />, tone: "emerald" },
	"deployment-promote": { label: "Promotion", icon: <FiUploadCloud />, tone: "orange" },
	"deployment-queue": { label: "Déploiement", icon: <FiUploadCloud />, tone: "sky" },
	"content-deploy-preview": { label: "Déploiement préversion", icon: <FiUploadCloud />, tone: "sky" },
	"content-deploy-production": { label: "Déploiement production", icon: <FiUploadCloud />, tone: "indigo" },
};

export const ACTIVITY_TONES: Record<ActivityTone, { dot: string; chip: string; icon: string }> = {
	emerald: { dot: "bg-emerald-500", chip: "bg-emerald-50 text-emerald-700 border-emerald-200", icon: "text-emerald-600" },
	orange: { dot: "bg-orange-500", chip: "bg-orange-50 text-orange-700 border-orange-200", icon: "text-orange-600" },
	sky: { dot: "bg-sky-500", chip: "bg-sky-50 text-sky-700 border-sky-200", icon: "text-sky-600" },
	indigo: { dot: "bg-indigo-500", chip: "bg-indigo-50 text-indigo-700 border-indigo-200", icon: "text-indigo-600" },
	slate: { dot: "bg-slate-400", chip: "bg-slate-50 text-slate-600 border-slate-200", icon: "text-slate-500" },
};

/** Returns the activity rendering for a log type, or undefined for non-activity logs. */
export const activityMetaFor = (type?: string | null): ActivityMeta | undefined =>
	type ? ACTIVITY_META[type.toLowerCase()] : undefined;
